import { render, staticRenderFns } from "./UserL.vue?vue&type=template&id=46a9e630"
import script from "./UserL.vue?vue&type=script&lang=js"
export * from "./UserL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports